var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 10C10.4853 10 12.5 8.0599 12.5 5.66667C12.5 3.27343 10.4853 1.33333 8 1.33333C5.51472 1.33333 3.5 3.27343 3.5 5.66667C3.5 8.0599 5.51472 10 8 10Z",
    stroke: "#7200B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.01333 9.01333L5.00667 13.9333C5.00667 14.5333 5.42668 14.8267 5.94668 14.58L7.73334 13.7333C7.88 13.66 8.12667 13.66 8.27334 13.7333L10.0667 14.58C10.58 14.82 11.0067 14.5333 11.0067 13.9333V8.89333",
    stroke: "#7200B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0,
    d: "M15.25 0.75V15.25H0.75V0.75H15.25Z",
    stroke: "#7200B0",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsMedal);
export default __webpack_public_path__ + "static/media/rewards-medal.5d10e3459da5d7139521119232391705.svg";
export { ForwardRef as ReactComponent };